import { Document } from '../base/document';

export class Input extends Document {
    static _type: string = 'Input';

    group?: any[];
    meta?: string;
    graphqlType?: string;

    constructor(source?: any) {
        super(source);

        if (source) {
            this.group = source.group;
            this.meta = source.meta;
            this.graphqlType = source.graphqlType;
        }
    }

    copy(source?: any) {
        super.copy(source);

        if (source) {
            this.group = source.group;
            this.meta = source.meta;
            this.graphqlType = source.graphqlType;
        }
    }
}
